// js
import reducer from './reducers';
import {updateAppTheme, updateBiometric} from './actions';

// constants
const actions = {updateAppTheme, updateBiometric};

export default {actions, reducer};
